import { Button, Input, Tooltip, Typography } from 'antd';
import { CheckCircleOutlined, CopyOutlined } from '@ant-design/icons';
import { useNotice } from '../NoticeStack';
import styles from './SheetCreated.module.css';

interface SheetCreatedProps {
  url: string;
}

// Итог выгрузки в Google: ссылка, копирование и «Открыть таблицу».
export function SheetCreated({ url }: SheetCreatedProps) {
  const notice = useNotice();

  // Буфер обмена может быть недоступен (нет разрешения, не https) — тогда
  // ссылку остаётся скопировать из поля руками.
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      notice.info('Ссылка скопирована');
    } catch {
      notice.error('Не удалось скопировать — выделите ссылку в поле');
    }
  };

  return (
    <div className={styles.root}>
      <CheckCircleOutlined className={styles.icon} aria-hidden />
      <Typography.Text strong className={styles.title}>Таблица создана</Typography.Text>
      <Input
        value={url}
        readOnly
        aria-label="Ссылка на таблицу"
        className={styles.url}
        suffix={(
          <Tooltip title="Скопировать ссылку">
            <button type="button" className={styles.copy} aria-label="Скопировать ссылку" onClick={copy}>
              <CopyOutlined />
            </button>
          </Tooltip>
        )}
      />
      <Button type="primary" href={url} target="_blank" rel="noopener noreferrer" className={styles.open}>
        Открыть таблицу
      </Button>
    </div>
  );
}
